import React, { Component } from 'react'

class State extends Component {
  // constructor(props){
  //   super();
  //   this.state = {
  //     ...this.props.initial
  //   }
  // }
  // ---- or ----
  state = {
    ...this.props.initial
  }
  
  render() {
    this.setState = this.setState.bind(this);
    // mostly we add bind method inside constructor, but here we are not using constructor, so we added inside render().
    //we added bind coz setState was loosing its property
    return (
      <>
        {/* {this.props.children} */}
        {/* {this.props.children()} */}
        {this.props.children({
          state: this.state,
          setState: this.setState
        })}
      </>
    )
  }
}

export default State;
